/* eslint-disable react/jsx-key */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Divider, Collapse, Button } from 'antd';
import { Input } from 'antd';
import { SearchOutlined, PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import GlossaryService from 'services/glossary';
import Loading from 'components/loading';
import Form from 'react-bootstrap/Form';
import { useGetGlossarioDownload } from 'services/GetGlossarioDownload';
import { downloadFile } from '../../assets/extra/helpers';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { Panel } = Collapse;

function Glossary({ isMobile, resetCounter, defaultSkip, queryString }) {

  const getGlossarioDownlaod = useGetGlossarioDownload();

  const { t } = useTranslation();
  const letters = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'X',
    'Y',
    'W',
    'Z'
  ];
  let selectedLetter = 'AZ';
  let searchString = null;

  const [inputValue, setInputValue] = useState(null);
  const [getDisable, setGetDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [glossary, setGlossary] = useState([]);
  const [filteredGlossary, setFilteredGlossary] = useState([]);
  const [titleSearch, setTitleSearch] = useState();
  const [downloadLetter, setDownloadLetter] = useState('AZ');
  const [oldCounter, setOldCounter] = useState(1);

  function handleKeyDown(event) {
    if (!getDisable && event.key === 'Enter') {
      event.preventDefault();
      const stringa = document.getElementsByName('lemma')[0].value.toLowerCase();
      searchString = stringa === '' ? null : stringa;
      fetchDataGlossary(searchString);  
    }
  }

  const fetchDataGlossary = (word, letter = undefined) => {
    const selectByString = glossary.filter((obj) => {
      if (obj.nome.toLowerCase().includes(searchString)) {
        return true;
      } else {
        return false;
      }
    });
    const markedSelectByString = selectByString.map((obj) => {
      const markedNome = obj.nome.replace(new RegExp(word, 'gi'), `<mark>${word}</mark>`);
      return { ...obj, nome: markedNome };
    });
    if (searchString?.trim().length > 0) {
      setFilteredGlossary(markedSelectByString);
      setTitleSearch(`Risultati filtrati per: ${word}`);
    } else {
      searchString = null;
      if (letter == 'AZ') {
        setFilteredGlossary(glossary);
        setTitleSearch(`${word}`);
      } else {
        setFilteredGlossary(glossary.filter((obj) => obj.nome[0] === letter));
        setTitleSearch(`Risultati filtrati per lettera: ${word}`);
      }
    }
  };

  const fetchGlossary = async () => {
    return await GlossaryService.glossary();
  };

  useEffect(() => {
    if (resetCounter !== oldCounter){
      fetchDataGlossary('Tutte le definizioni', 'AZ');
      setInputValue(null);

      setOldCounter(resetCounter);
    }
  }, [resetCounter]);

  useEffect(async () => {
    if (defaultSkip) defaultSkip(true);
    if (queryString) queryString('');     
    document.title = 'Glossario - SITUAS';
    setLoading(true);
    await fetchGlossary()
      .then(({ data }) => {
        setGlossary(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (inputValue === null) {
      setGetDisable(true);
    }
  }, [inputValue]);

 useEffect(() => {
    fetchDataGlossary('Tutte le definizioni', 'AZ');
  }, [glossary]);

  const DownloadGlossario = async () => {
    const file = await getGlossarioDownlaod.execute(
      `${downloadLetter != 'AZ' ? `?pfilter=${downloadLetter}` : ''}`
    );
    downloadFile(file, file.filename ? file.filename : `glossario ${downloadLetter}.xlsx`);
  };

  return (
    <main id="main-content" className={`pb-4 pt-3 pb-4 bs-docs-section clearfix`}>
      <Row>
        {loading && <Loading fullPage={true} />}
        <Col
          className="mt-5 pt-2"
          xs={24}
          lg={7}
          aria-label="Filtri e ricerca del glossario"
          role="search"
          name="Criteri di ricerca">
          <div className="glossary-criteri-container">
            <h3 className="text-secondary">Criteri di ricerca</h3>
            <div id="indice" className="mt-1">
              Indice alfabetico
            </div>
            <form aria-labelledby="indice">
              <ul role="list" aria-describedby="descrizione-selettore" className="glossary-letters">
                {glossary.length > 0 &&
                  letters.map((letter, index) => (
                    <li key={`letter-${index}`}>
                      <button
                        tabIndex={0}
                        type="button"
                        disabled={!glossary.filter((obj) => obj.nome[0] === letter).length > 0}
                        onClick={() => {
                          selectedLetter = letter;
                          fetchDataGlossary(letter, letter);
                          setDownloadLetter(letter);
                        }}
                        key={letter}>
                        {letter}
                      </button>
                    </li>
                  ))}
                <li>
                  <button
                    className="totBtn"
                    type="button"
                    onClick={() => {
                      searchString = null;
                      selectedLetter = 'AZ';
                      setDownloadLetter('AZ');
                      fetchDataGlossary('Tutte le definizioni', selectedLetter);
                    }}
                    key={'AZ'}>
                    A-Z
                  </button>
                </li>
                <p id="descrizione-selettore" className="sr-only">
                  Seleziona una lettera per filtrare i lemmi del glossario
                </p>
              </ul>

              <Divider className="blue-divider" />
              <Form.Group>
                <Form.Label
                  className="mt-4"
                  htmlFor="cerca"
                  role="search"
                  aria-label="Filtri e ricerca del glossario">
                  Cerca nei lemmi
                </Form.Label>
                <Input
                  tabIndex={0}
                  value={inputValue}
                  onChange={(e) => {
                    setInputValue(e.target.value);
                    searchString = inputValue?.toLowerCase();
                    if (e.target.value != '') {
                      setGetDisable(false);
                    } else {
                      setGetDisable(true);
                    }
                  }}
                  onKeyDown={handleKeyDown}
                  onFocus={() => {
                    if (!inputValue && !filteredGlossary) {
                      fetchDataGlossary('Tutte le definizioni', 'AZ');
                    }
                  }}
                  className="glossary-search mb-3"
                  placeholder="Cerca"
                  prefix={<SearchOutlined />}
                  name="lemma"
                  id="cerca"
                />
                <Button
                  aria-describedby="searchResultsStatus"
                  tabIndex={0}
                  className={`glossario-button mt-2 ${getDisable ? 'btn-search-disabled' : ''}`}
                  aria-disabled={getDisable}
                  onClick={() => {
                    if (!getDisable) {
                      const stringa = document.getElementsByName('lemma')[0].value.toLowerCase();
                      searchString = stringa === '' ? null : stringa;
                      fetchDataGlossary(searchString);
                      setDownloadLetter('AZ');
                    }
                  }}
                  >
                  Cerca
                </Button>
                <Button
                  tabIndex={0}
                  className="glossario-button mt-2 mb-5"
                  onClick={() => {
                    fetchDataGlossary('Tutte le definizioni', 'AZ');
                    setInputValue(null);
                  }}>
                  Annulla
                </Button>
              </Form.Group>
            </form>
          </div>
        </Col>

        <Col className={`custom-scroll`} xs={23} lg={16} offset={1}>
          {/* 
          <div
            id="downloadButton"
            role="button"
            title=" Scarica XLSX"
            loading={getGlossarioDownlaod.isLoading}
            tabIndex="0"
            onClick={() => {
              DownloadGlossario();
            }}
            onKeyDown={(e)=> {
              if (e.key === "Enter"){
                DownloadGlossario();
              }
            }}>
            {<FontAwesomeIcon aria-hidden="true" icon={faFileExcel} size="xl" />}
          </div>
          */}
          <h2 className="title-main ">{t('glossario.title')}</h2>

          <Divider className="blue-divider" />
          <div>{t('glossario.subtitle')}</div>
          {!loading && (
            <h3 className="glossary-letter mt-3" role="status">
              {titleSearch}
                <span className="sr-only">
                  , {filteredGlossary?.length === 1 ? 
                    `trovata ${filteredGlossary.length} definizione` :
                    `trovate ${filteredGlossary?.length ?? 0} definizioni`}
                </span>
            </h3>
          )}
          <div role="status" style={{ display: filteredGlossary?.length > 0 ? 'none' : 'block' }}>
            Nessun risultato trovato.
          </div>
          <div className="mb-4">
            <Collapse
              /*style={{ overflowY: filteredGlossary?.length > 8 ? 'scroll' : 'hidden'}}*/
              style={{ display:'contents' }}
              expandIcon={({ isActive }) =>
                !isActive ? (
                  <PlusCircleOutlined aria-label='Espandi lemma' style={{ fontSize: '15px' }} />
                ) : (
                  <MinusCircleOutlined aria-label="Chiudi lemma" style={{ fontSize: '15px' }} />
                )
              }
              className="elements-container">
              {filteredGlossary.map((obj, index) => (
                <Panel
                      header={
                    <span id={'collapseheader-' + index} style={{ fontSize: '1.1rem', fontWeight: 500, color: 'black' }} dangerouslySetInnerHTML={{ __html: `${obj.nome}` }} />
                  }
                  key={obj.nome}>
                  <div className="pl-4">
                    {obj.descrizione}
                    <Divider
                      style={{ marginTop: '8px', marginBottom: '2px', borderColor: 'gray' }}
                      dashed
                    />
                    <div className="glossary-source">
                      <span style={{ fontSize: '15px' }}>Fonte:</span>
                      <span style={{ color: '#426F80', fontWeight: '500', fontSize: '15px' }}>
                        {' ' + obj.fonte}
                      </span>
                      {obj.links?.length > 0 &&
                        <div className="mt-2">
                          {obj.links.map((item, i) => (
                            <div key={i}>
                              <a className="glossary-result-link" href={item.link} alt={`link ${item.hyperlink}`}>
                                {item.hyperlink}
                              </a>
                            </div>
                          ))}
                        </div>
                      }
                    </div>
                  </div>
                </Panel>
              ))}
            </Collapse>
          </div>
        </Col>
      </Row>
    </main>
  );
}
export default Glossary;
